import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./NaverClusterMarker.module.scss";
export const clusterMarkerSizes = ["XS", "S", "M", "L", "XL"];
export const NaverClusterMarker = ({ type }) => {
    return (_jsx("div", { "data-testid": "naverClusterMarker", className: classNames(styles.wrapper, styles[`background${type}`]) }));
};
//# sourceMappingURL=NaverClusterMarker.js.map